import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/annadirSugerenciasExtraccionPlanning`, method: 'POST', body: values, token: token})
}